import script from "./MaterialLogicMindMapManage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MaterialLogicMindMapManage.vue?vue&type=script&lang=ts&setup=true"

import "./MaterialLogicMindMapManage.vue?vue&type=style&index=0&id=9c2d71c0&lang=css"

const __exports__ = script;

export default __exports__